"use client";

import React from "react";
import { WifiOff } from "lucide-react";
import ErrorPage from "@/components/errors/ErrorPage";
import "./OfflineErrorPage.css";

export default function OfflineErrorPage() {
    return (
        <div className="error-503-page">
            <ErrorPage
                code={503}
                background="#FEF2F2"
                accent="var(--error-page-accent, #DC2625)"
                title="ERROR 503"
                primaryActionStyle={{ top: 700 }}
                secondaryActionStyle={{ top: 800 }}
                message={
                    <>
                        <div style={{ marginBottom: 8 }}>
                            Service Unavailable
                        </div>
                        <div>
                            <span
                                style={{ display: "block", textAlign: "left" }}
                            >
                                Try:
                            </span>
                            <ul style={{ display: "block", textAlign: "left" }}>
                                <li>Checking your internet connection</li>
                                <li>Reconnecting to Wi-Fi</li>
                                <li>
                                    Refreshing the page and trying again in a
                                    few minutes
                                </li>
                            </ul>
                        </div>
                    </>
                }
                icon={
                    <WifiOff
                        aria-hidden="true"
                        size={91}
                        strokeWidth={1.8}
                        color="var(--error-page-accent, #DC2625)"
                    />
                }
                primaryAction={{
                    kind: "retry",
                    label: "Try Again",
                    onRetry: () => window.location.reload(),
                }}
                secondaryAction={{
                    kind: "link",
                    label: "Back to Home",
                    href: "/",
                }}
            />
        </div>
    );
}
